module.exports = __webpack_public_path__ + "static/media/limitedTimeOffersIcon.eca28799.svg";